module.exports = __webpack_public_path__ + "img/portfolio-6.70fae66f.jpg";